import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suitePurchaseMotionsMapSelector } from '../../selectors/PurchaseMotionSelectors';
import SuiteAuthedCTAs from '../merch-card/SuiteAuthedCTAs';

const FeatureTableHeaderCellCTA = ({
  productLevel,
  trackingSource
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const suitePurchaseMotions = useSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return [];
    const purchaseMotionsMap = suitePurchaseMotionsMapSelector(state);
    return purchaseMotionsMap[productLevel];
  });
  if (!suitePurchaseMotions || !suitePurchaseMotions.length) return null;
  return /*#__PURE__*/_jsx(SuiteAuthedCTAs, {
    productLevel: productLevel,
    buttonUses: ['primary', 'secondary'],
    purchaseMotions: [suitePurchaseMotions[0]],
    trackingSource: trackingSource,
    ctaStyles: {
      width: '154px'
    },
    isEbx633: true
  });
};

export default FeatureTableHeaderCellCTA;